export const siteConfig = {
  // Parent legal entity
  parent: {
    name: "Mods Enterprises",
    full: "Mods Enterprises, LLC",
  },
  // Catapult — custom homes division
  catapult: {
    name: "Catapult",
    tagline: "Development & Design",
    fullName: "Catapult Development & Design",
    description: "We design homes, not just build them.",
    phone: "(515) 555-0142",
    email: "hello@modsenterprises.com",
    address: "5249 N Park Pl NE, Cedar Rapids, IA 52402",
    minBudget: "$550,000",
  },
  // Mods Enterprises — rentals & developments division
  mods: {
    name: "Mods Enterprises",
    tagline: "Real Estate",
    fullName: "Mods Enterprises",
    description: "Real estate that builds long-term wealth.",
    phone: "(515) 555-0142",
    email: "invest@modsenterprises.com",
    address: "5249 N Park Pl NE, Cedar Rapids, IA 52402",
  },
  // Backwards-compat — current Catapult code reads siteConfig.name etc directly.
  // These mirror the catapult block so existing pages keep working unchanged.
  name: "Catapult",
  tagline: "Development & Design",
  fullName: "Catapult Development & Design",
  description: "We design homes, not just build them.",
  phone: "(515) 555-0142",
  email: "hello@modsenterprises.com",
  address: "5249 N Park Pl NE, Cedar Rapids, IA 52402",
  minBudget: "$550,000",
};

// Catapult — Featured Home (most recent build that represents the studio's next phase).
export const catapultFeaturedHome = {
  address: "1615 38th St SE",
  city: "Cedar Rapids, IA 52403",
  tag: "Now Listed · Built 2026",
  price: "$524,900",
  beds: 4,
  baths: 3,
  sqft: "2,830",
  headline: "Where California modern meets Midwest comfort.",
  blurb:
    "Residence 1615 is a one-of-one custom home — conceived from an original floor plan, not a stock design. Expansive 9' ceilings, oversized 7'5\" interior doors, a Scandinavian-inspired kitchen with waterfall island, and a spa-inspired primary suite with a custom walk-in closet.",
  externalUrl:
    "https://www.zillow.com/homedetails/1615-38th-St-SE-Cedar-Rapids-IA-52403/247356293_zpid/",
  externalLabel: "View on Zillow",
  photos: [
    {
      src: "https://customer-assets-jt897jd0.emergentagent.net/job_architect-dreams/artifacts/08s1coap_1615_38th_St_SE-11.webp",
      caption: "Living Room · Electric fireplace, walnut cabinetry",
    },
    {
      src: "https://customer-assets-jt897jd0.emergentagent.net/job_architect-dreams/artifacts/di4le3uh_1615_38th_St_SE-29.webp",
      caption: "Open Concept · Living, dining & kitchen flow",
    },
    {
      src: "https://customer-assets-jt897jd0.emergentagent.net/job_architect-dreams/artifacts/aa7xpxqn_1615_38th_St_SE-05.webp",
      caption: "Kitchen · Waterfall island, slab backsplash, designer lighting",
    },
    {
      src: "https://customer-assets-jt897jd0.emergentagent.net/job_architect-dreams/artifacts/g9hmd48d_1615_38th_St_SE-28.webp",
      caption: "Primary Bath · Floating vanities, backlit mirror",
    },
    {
      src: "https://customer-assets-jt897jd0.emergentagent.net/job_architect-dreams/artifacts/zgw529nn_1615_38th_St_SE-06.webp",
      caption: "Walk-in Closet · Illuminated custom cabinetry",
    },
  ],
};

// External link to the standalone Ellis Row site (separate preview)
export const ellisRowSite = "https://ellis-discover.preview.emergentagent.com";

export const heroData = {
  headline: "Where Your Future\nHome Begins",
  subheadline: "We design homes that reflect your life, your vision, and your story — crafted with intention from the very first sketch.",
  backgroundImage: "https://images.unsplash.com/photo-1639173925921-5d5fd027713c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzcxNTUyMDc0fDA&ixlib=rb-4.1.0&q=85",
  ctaPrimary: "Start Your Journey",
  ctaSecondary: "Explore Design Styles",
};

export const designStyles = [
  {
    id: "modern",
    title: "Modern",
    subtitle: "Clean Lines, Bold Statements",
    description: "Sleek, minimal, and architecturally forward. Open floor plans meet dramatic materials for a home that feels like living art.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2000&q=85",
  },
  {
    id: "traditional",
    title: "Traditional",
    subtitle: "Timeless Elegance, Enduring Charm",
    description: "Classic proportions, refined details, and warm materials that honor the art of home building with a contemporary sensibility.",
    image: "https://images.unsplash.com/photo-1706799405374-c77785809b39?auto=format&fit=crop&w=2000&q=85",
  },
  {
    id: "farmhouse",
    title: "Modern Farmhouse",
    subtitle: "Warmth Meets Sophistication",
    description: "The perfect balance of rustic charm and modern refinement. Board-and-batten exteriors, open kitchens, and spaces made for gathering.",
    image: "https://images.unsplash.com/photo-1662505899914-1000c566477b?auto=format&fit=crop&w=2000&q=85",
  },
  {
    id: "ranch",
    title: "Ranch",
    subtitle: "Single-Level Luxury Living",
    description: "Expansive, grounded, and effortlessly connected to the landscape. One-level living reimagined for modern families.",
    image: "https://images.unsplash.com/photo-1628744448839-a475cc0e90c3?auto=format&fit=crop&w=2000&q=85",
  },
];

export const approachSteps = [
  {
    number: "01",
    title: "Discovery",
    description: "We begin with a deep conversation about your life, your land, and your vision. This isn't a sales pitch — it's the start of a creative partnership.",
  },
  {
    number: "02",
    title: "Design",
    description: "Our design team crafts your home from the inside out — spaces that flow naturally, light that inspires, and details that delight.",
  },
  {
    number: "03",
    title: "Refine",
    description: "Through collaborative iteration, we refine every element until your home feels unmistakably yours. Every corner considered, every material chosen with care.",
  },
  {
    number: "04",
    title: "Build",
    description: "With meticulous craftsmanship and transparent communication, we bring your vision to life — on time, on budget, and beyond expectation.",
  },
];

export const galleryImages = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1640109478916-f445f8f19b11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzcxNTUyMDc0fDA&ixlib=rb-4.1.0&q=85",
    title: "Emerald Suite",
    category: "Modern",
    span: "large",
  },
  {
    id: 2,
    src: "https://images.pexels.com/photos/6585741/pexels-photo-6585741.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Marble Retreat",
    category: "Spa Bath",
    span: "medium",
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1758945314651-05121c4083c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxjdXN0b20lMjBob21lJTIwZGVzaWduJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3MTU1MjA3N3ww&ixlib=rb-4.1.0&q=85",
    title: "Oak & Light",
    category: "Modern",
    span: "medium",
  },
  {
    id: 6,
    src: "https://images.pexels.com/photos/3754595/pexels-photo-3754595.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "The Loft",
    category: "Contemporary",
    span: "large",
  },
];

export const testimonials = [
  {
    id: 1,
    quote: "Catapult didn't just build our home — they understood how we wanted to live in it. Every detail was considered, every space intentional.",
    author: "Sarah & James M.",
    location: "West Des Moines, IA",
    project: "Modern Farmhouse",
  },
  {
    id: 2,
    quote: "The design process was unlike anything we've experienced. It felt like working with an architect and a therapist — they truly listened.",
    author: "Michael & Laura K.",
    location: "Ankeny, IA",
    project: "Contemporary Ranch",
  },
  {
    id: 3,
    quote: "From the first meeting to move-in day, the experience was seamless. Our home feels like it was always meant to be here.",
    author: "David & Rachel T.",
    location: "Urbandale, IA",
    project: "Traditional Estate",
  },
];

export const questionnaireSteps = [
  {
    id: 1,
    question: "What style resonates with you?",
    subtitle: "Choose the aesthetic that speaks to your soul.",
    type: "image-choice",
    options: [
      {
        value: "modern",
        label: "Modern",
        image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2000&q=85",
      },
      {
        value: "traditional",
        label: "Traditional",
        image: "https://images.unsplash.com/photo-1706799405374-c77785809b39?auto=format&fit=crop&w=2000&q=85",
      },
      {
        value: "farmhouse",
        label: "Modern Farmhouse",
        image: "https://images.unsplash.com/photo-1662505899914-1000c566477b?auto=format&fit=crop&w=2000&q=85",
      },
      {
        value: "ranch",
        label: "Ranch",
        image: "https://images.unsplash.com/photo-1628744448839-a475cc0e90c3?auto=format&fit=crop&w=2000&q=85",
      },
    ],
  },
  {
    id: 2,
    question: "How do you envision your life at home?",
    subtitle: "Select all that describe your ideal lifestyle.",
    type: "multi-choice",
    options: [
      { value: "entertaining", label: "Love entertaining guests" },
      { value: "outdoor", label: "Indoor-outdoor living" },
      { value: "family", label: "Spaces for a growing family" },
      { value: "retreat", label: "A personal retreat & sanctuary" },
      { value: "workspace", label: "Home office & creative space" },
      { value: "wellness", label: "Wellness & spa-like bathrooms" },
    ],
  },
  {
    id: 3,
    question: "Do you have a lot or land?",
    subtitle: "This helps us understand where you are in the process.",
    type: "single-choice",
    options: [
      { value: "yes", label: "Yes, I have a lot ready" },
      { value: "searching", label: "Currently searching for land" },
      { value: "help", label: "I need help finding the right lot" },
      { value: "unsure", label: "Not sure yet" },
    ],
  },
  {
    id: 4,
    question: "When are you hoping to begin?",
    subtitle: "Every great home starts with the right timing.",
    type: "single-choice",
    options: [
      { value: "asap", label: "As soon as possible" },
      { value: "6months", label: "Within 6 months" },
      { value: "1year", label: "Within a year" },
      { value: "exploring", label: "Just exploring for now" },
    ],
  },
  {
    id: 5,
    question: "What's your investment range?",
    subtitle: "Our custom homes start at $550,000. This helps us tailor the experience to you.",
    type: "single-choice",
    options: [
      { value: "550-750", label: "$550,000 – $750,000" },
      { value: "750-1m", label: "$750,000 – $1,000,000" },
      { value: "1m-1.5m", label: "$1,000,000 – $1,500,000" },
      { value: "1.5m+", label: "$1,500,000+" },
    ],
  },
  {
    id: 6,
    question: "Which kitchen aesthetic feels most like yours?",
    subtitle: "The kitchen sets the tone for the entire home. Choose the style you're drawn to — we'll build from there.",
    type: "image-choice",
    options: [
      {
        value: "american",
        label: "American",
        description: "Warm wood, custom millwork, statement island — familiar comfort done well.",
        image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1200&q=80",
      },
      {
        value: "scandinavian",
        label: "Scandinavian",
        description: "Light wood, white walls, minimal hardware — calm, bright, functional.",
        image: "https://images.unsplash.com/photo-1590474504715-91ae491e4938?auto=format&fit=crop&w=1200&q=80",
      },
      {
        value: "japandi",
        label: "Japandi",
        description: "Warm neutral palette, natural textures, quiet luxury — Japanese restraint meets Scandinavian softness.",
        image: "https://images.unsplash.com/photo-1628745277866-0c4468030a81?auto=format&fit=crop&w=1200&q=80",
      },
      {
        value: "japanese",
        label: "Japanese",
        description: "Precise joinery, tatami proportions, deep wood tones — disciplined, quiet, intentional.",
        image: "https://images.unsplash.com/photo-1556912173-46c336c7fd55?auto=format&fit=crop&w=1200&q=80",
      },
    ],
  },
  {
    id: 7,
    question: "What are your must-haves?",
    subtitle: "Dream big — select everything that matters to you.",
    type: "multi-choice",
    options: [
      { value: "open-kitchen", label: "Open concept kitchen" },
      { value: "master-suite", label: "Luxurious master suite" },
      { value: "outdoor-living", label: "Outdoor living space" },
      { value: "home-office", label: "Dedicated home office" },
      { value: "mudroom", label: "Mudroom & storage" },
      { value: "3car-garage", label: "3+ car garage" },
      { value: "walkout-basement", label: "Walk-out basement" },
      { value: "spa-bath", label: "Spa-like bathroom" },
    ],
  },
  {
    id: 8,
    question: "Tell us about your dream home.",
    subtitle: "Share any inspiration, ideas, or things you've always wanted. We're listening.",
    type: "textarea",
    placeholder: "Describe your vision... What does your dream home look and feel like?",
  },
  {
    id: 9,
    question: "Let's get to know you.",
    subtitle: "We'd love to start a conversation about your future home.",
    type: "contact",
    fields: [
      { name: "firstName", label: "First Name", type: "text" },
      { name: "lastName", label: "Last Name", type: "text" },
      { name: "email", label: "Email", type: "email" },
      { name: "phone", label: "Phone", type: "tel" },
    ],
  },
];

export const investmentInfo = {
  headline: "An Investment in\nExceptional Living",
  intro: "Building a custom home is one of life's most meaningful investments. We believe in transparency, and we want to ensure our partnership is the right fit from the start.",
  minimumBudget: "$550,000",
  sections: [
    {
      title: "What's Included",
      items: [
        "Complete architectural design & engineering",
        "Interior design consultation & material selection",
        "Full project management from permit to move-in",
        "Premium materials & trusted craftsman partnerships",
        "Transparent pricing with no hidden costs",
      ],
    },
    {
      title: "The Catapult Difference",
      items: [
        "Design-driven approach, not just construction",
        "One-on-one collaboration with our creative team",
        "Curated material palettes for every project",
        "Commitment to timelines & clear communication",
        "A home that's truly, unmistakably yours",
      ],
    },
  ],
};

export const navLinks = [
  { label: "Our Approach", path: "/catapult/approach" },
  { label: "Design Styles", path: "/catapult/styles" },
  { label: "Investment", path: "/catapult/investment" },
  { label: "Contact", path: "/catapult/contact" },
];

export const modsNavLinks = [
  { label: "Portfolio", path: "/mods#portfolio" },
  { label: "Featured Home", path: "/mods#featured" },
  { label: "Ellis Row", path: "/mods#ellis-row" },
  { label: "Investors", path: "/mods#investors" },
  { label: "Contact", path: "/mods#contact" },
];

// Mods rentals portfolio — real company history.
export const modsPortfolio = {
  intro: {
    headline: "A privately held portfolio,\nbuilt one property at a time.",
    body: "Since 2019 we've acquired and rehabbed single-family homes across central Iowa — running rentals, short-term stays, flips, and ground-up new construction. Ellis Row is our first multi-family build.",
  },
  portfolioTeaser: [
    {
      name: "Single-Family Rentals",
      status: "Fully Leased",
      note: "Three active long-term rentals in Cedar Rapids — 1407 & 1432 7th Ave SE and 1743 E Ave NE.",
    },
    {
      name: "Ellis Row Townhomes",
      status: "Coming Fall 2026",
      note: "Our first multi-family build — 7 new townhomes, pre-leasing now open.",
    },
  ],
  activeRentals: [
    { address: "1407 7th Ave SE", city: "Cedar Rapids, IA", note: "Featured · full gut-rehab" },
    { address: "1432 7th Ave SE", city: "Cedar Rapids, IA", note: "Long-term rental" },
    { address: "1743 E Ave NE", city: "Cedar Rapids, IA", note: "Long-term rental" },
  ],
  // Chronological operating history
  timeline: [
    { year: "2019", title: "Portfolio begins", note: "Started acquiring and full gut-rehabbing single-family homes — long-term rentals, fix-and-flips, sale units, and short-term / AirBnB." },
    { year: "2023 · Spring", title: "First RFP submitted", note: "Submitted our first Request for Proposal for a multi-family project. Not awarded — but the proposal sharpened the playbook." },
    { year: "2023 · Winter", title: "Second RFP — awarded", note: "Second RFP submission, awarded for the Ellis Row Townhomes project." },
    { year: "2024", title: "First new-construction build", note: "408 4th Ave SW — our first ground-up new construction." },
    { year: "2025", title: "Second new-construction build", note: "1615 38th St SE — our second new construction, currently finishing." },
    { year: "2026", title: "Ellis Row breaks ground", note: "Our first multi-family build — 7 townhomes. Coming Fall 2026." },
  ],
  // Dedicated showcase — 1407 7th Ave SE (active rental)
  featuredProperty: {
    address: "1407 7th Ave SE",
    city: "Cedar Rapids, IA",
    tag: "Portfolio · Active Rental",
    headline: "A full gut-rehab, finished with the same care as a new build.",
    blurb:
      "One of our long-term rentals — taken down to the studs and reimagined with a modern interior, open-concept main floor, and a finished lower level. Every surface, fixture, and detail was selected in-house.",
    photoBase: "/properties/1407-7th-ave-se",
    photos: Array.from({ length: 25 }, (_, i) => `${String(i + 1).padStart(2, "0")}.jpg`),
  },
  // Other homes — builds and sold properties (visitor can browse)
  externalListings: [
    {
      address: "408 4th Ave SW",
      city: "Cedar Rapids, IA",
      note: "2024 · First New Construction Build",
      source: "Zillow",
      url: "https://www.zillow.com/homedetails/408-4th-Ave-SW-Cedar-Rapids-IA-52404/148837171_zpid/",
    },
    {
      address: "1428 7th Ave SE",
      city: "Cedar Rapids, IA",
      note: "Short-term rental · Sold",
      source: "Realtor.com",
      url: "https://www.realtor.com/realestateandhomes-detail/1428-7th-Ave-SE_Cedar-Rapids_IA_52403_M87130-36051",
    },
  ],
  investors: {
    headline: "Partner with us on the next development.",
    body: "We work with a small group of capital partners on equity participation in new build-to-rent developments and joint-venture acquisitions. If long-hold real estate, design-led construction, and the central Iowa market interest you — let's start a conversation.",
    bullets: [
      "Equity partnerships on new build-to-rent developments",
      "Joint-venture acquisitions of multi-family rentals",
      "Long-hold strategy with disciplined underwriting",
      "Privately held — no fund layer, no AUM fees",
    ],
  },
};
